import React from 'react';
import Logo from '../components/Logo';
import ProjectDetailsSection from "../components/ProjectDetailsSection";

function ProjectDetails() {
  return (
    <>
      <Logo />
      <ProjectDetailsSection />
    </>
  );
}

export default ProjectDetails;